var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tag", style: `background: ${_vm.bgColor}` },
    [_vm._t("icon"), _c("div", { staticClass: "text" }, [_vm._t("text")], 2)],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }